export default __webpack_public_path__ + "static/serviceHubVp1-edab872f08b99ff725be9f4cf657778a.png";